import { LottieAnimationTypes } from '../lottieAnimation.types';

const config = { [LottieAnimationTypes.BarGraph]: {
  views: {
    default: {
      canvasHeight: 500,
      canvasWidth: 500,
      iconWidth: 260,
      iconHeight: 293,
      offsetLeft: 108,
    },
  },
  colors: {
    bar1: '#0078ce',
    bar2: '#0078ce',
    bar3: '#0078ce',
    bar4: '#0078ce',
  },
  gradients: {},
  frameRate: 60,
  segments: {
    default: [0, 150] as const,
  },
  getJson: () => import(
    /* webpackChunkName: "animations/bar-graph.json" */
    './bar-graph.json'
  ),
} };

export const { BarGraph } = config;
